/* global window */

import { Component } from 'react';
import { connect } from 'react-redux';

class APIError extends Component {
  componentDidUpdate() {
    if (this.errorNode) {
      this.errorNode.scrollIntoView();
      window.scrollBy(0, -150);
    }
  }

  render() {
    const { apiError, position, modal, cart } = this.props;
    // If we dont have api errors
    if (!apiError) {
      return null;
    }
    if (
      (position === 'modal' && modal.isOpen) ||
      (position === 'layout' && !modal.isOpen) ||
      (position === 'sideCart' && !modal.isOpen && cart.isSideCartVisible)
    ) {
      return (
        <div
          className="c7-message--error"
          ref={(div) => {
            this.errorNode = div;
          }}
        >
          {apiError}
        </div>
      );
    }
    return null;
  }
}

const mapStateToProps = (state) => ({
  apiError: state.apiError,
  modal: state.modal,
  cart: state.cart
});

export default connect(mapStateToProps)(APIError);
